import { createContext } from 'react';
import type { CabinetConfig } from './types';
import type { StorageScope } from '../../lib/storage';

export interface CabinetCtx {
  config: CabinetConfig;
  scope: StorageScope;
}

/**
 * Контекст живёт в отдельном НЕ-компонентном файле намеренно:
 * eslint-правило react-refresh/only-export-components (а `npm run lint` идёт
 * с --max-warnings 0) запрещает экспортировать из одного файла и компонент,
 * и не-компонент. Провайдер — в CabinetConfigContext.tsx, хук — в useCabinet.ts.
 */
export const CabinetContext = createContext<CabinetCtx | null>(null);
